var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsScheduledReportActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 18.2 18.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics-business-chart-finance-graph-money-svgrepo-com",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M1,19.456A1.456,1.456,0,0,1,2.456,18H4.64A1.456,1.456,0,0,1,6.1,19.456V23.1A1.456,1.456,0,0,1,4.64,24.552H2.456A1.456,1.456,0,0,1,1,23.1Zm3.64.291a.291.291,0,0,0-.291-.291h-1.6a.291.291,0,0,0-.291.291V22.8a.291.291,0,0,0,.291.291h1.6A.291.291,0,0,0,4.64,22.8Z",
    transform: "translate(0 -4.624)",
    fill: "#1450ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M10,2.456A1.456,1.456,0,0,1,11.456,1H13.64A1.456,1.456,0,0,1,15.1,2.456V18.472a1.456,1.456,0,0,1-1.456,1.456H11.456A1.456,1.456,0,0,1,10,18.472Zm3.64.291a.291.291,0,0,0-.291-.291h-1.6a.291.291,0,0,0-.291.291V18.181a.291.291,0,0,0,.291.291h1.6a.291.291,0,0,0,.291-.291Z",
    transform: "translate(-2.448)",
    fill: "#1450ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M19,10.456A1.456,1.456,0,0,1,20.456,9H22.64A1.456,1.456,0,0,1,24.1,10.456V20.648A1.456,1.456,0,0,1,22.64,22.1H20.456A1.456,1.456,0,0,1,19,20.648Zm3.64.291a.291.291,0,0,0-.291-.291h-1.6a.291.291,0,0,0-.291.291v9.61a.291.291,0,0,0,.291.291h1.6a.291.291,0,0,0,.291-.291Z",
    transform: "translate(-4.896 -2.176)",
    fill: "#1450ff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsScheduledReportActiveIcon);
export default __webpack_public_path__ + "static/media/settings-scheduled-report-active-icon.1645fe55d9a6ac509056270461748f59.svg";
export { ForwardRef as ReactComponent };